import React, { Component, useEffect, useState } from 'react';
import MenuItems from './MenuItemsView';
import ExtraItem from './ExtraItemController';
import Carts from './CartsController';
import PlaceOrder from './PlaceOrderController';
import OrderResult from './OrderResultController';
import AddCard from '../order-cards/AddCard'
import { getCurrency,callCartItemListeners, callRefreshMyOrderListeners, getAppCfg, setAddCardInfo } from '../../utils/common';
import { setOrderCache, order_key, getOrderCache, clearOrder, getCrosssellProducts, setBeingSelected, clearCartItems } from '../../utils/order_cache';
import crmservices from '../../wsclient/crmservices';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import Loading from '../../components/Loading';
import SelectPaymentMethodController from './SelectPaymentMethodController';
import OrderMerchantsController from './OrderMerchantsController';
import OrderStoresController from './OrderStoresController';
import MyProfile from '../my-profile/MyProfile';
import ModalConfirm from '../../components/ModalConfirm';
import Cards from '../order-cards/Cards';
import { newGUID } from '../../utils/util';
import { portalCfg } from '../../../portal.router.config';
function MenuItemsController(props) {

    const [mode, setMode] = useState('add');
    const [active, setActive] = useState('menu');
    const [showLoading, onShowLoading] = useState(false);
    const [showLoadingProcess, onShowLoadingProcess] = useState(false);
    const [subCategories, setSubCategories] = useState([]);
    const order_type = getOrderCache(order_key.order_type, true);
    const [menuItems, setMenuItems] = useState([]);
    const [categorySelected, setCategorySelected] = useState({});
    const [variations, setVariations] = useState([]);
    const [variationSelected, setVariationSelected] = useState(null);
    const [product_selected, setProductSelected] = useState(null);
    const [subCategorySelected, setSubCategorySelected] = useState(null);
    const [message, setMessage] = useState({});
    const [allCategories, setAllCategories] = useState([]);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [totalAmountBaseItem, setTotalAmountBaseItem] = useState(0);
    const [menuItemLength, setMenuItemLength] = useState(0);
    const [isUseWalletFund, setUseWalletFund] = useState(undefined);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [requestAmountFromWalletFunds, setRequestAmountFromWalletFunds] = useState(undefined);
    const [isValidAmountWalletFund, setValidAmountWalletFund] = useState(undefined);
    const [orderCatalog, setOrderCatalog] = useState(undefined);
    const [availabelWalletFund, setAvailabelWalletFund] = useState(0);
    const [order_notes, setOrderNotes] = useState(null);
    const [primary_card, setPrimaryCard] = useState(null);
    const [primary_paypal, setPrimaryPaypal] = useState(null);
    const [html_add_card_content, setHtmlAddCardContent] = useState(null);

    const [confirm, setConfirm] = useState({});

    useEffect(()=>{
        init();
    },[])    
    const init = async() =>{
        await onLoadCards();
        if(props.openFromHeader || props.reOrder){
            onEstimateOrder()
        }
        var orderCatalog = await getOrderCache(order_key.catalog_selected)
        // console.log('orderCatalog===', orderCatalog)
        setOrderCatalog(orderCatalog);
        if(orderCatalog){
            await getOrderCategories(orderCatalog)
        }
        else{
            await onLoadCategories();
        }

        
    }

    const getOrderCategories = async(orderCatalog) =>{
        onShowLoading(true);
        try {
            var result = await crmservices.orders.getOrderCategories({}, orderCatalog.id);
            var categories = result.data && result.data.content ? result.data.content : [];
            if (categories.length > 0) {
                setCategorySelected(categories[0]);
                await getOrderSubCategories(categories[0].id, orderCatalog);
            }
            setOrderCache(order_key.order_categories, categories);
        } catch (error) {
            console.log("get all categories exception:", error);
        }
        onShowLoading(false);
    }
    const getOrderSubCategories = async(parentID, orderCatalog) =>{

        //console.log("AAA orderCatalog:", orderCatalog);
        var categories = [];
        try {
            var result = await crmservices.orders.getOrderCategories({ parent_id: parentID }, orderCatalog.id);
            //console.log('getOrderSubCategories ressult==', result)
            if (result.code == 'OK') {
                categories = result.data.content ? result.data.content : [];
            }
        } catch (error) {
            console.log("load sub category:", error);
        }


        //console.log('categories ==', categories)
        setSubCategories(categories);
        setSubCategorySelected(categories.length > 0 ? categories[0]: undefined)
        await onLoadMenuItems({ category_id: categories.length > 0 ? categories[0].id: undefined }, orderCatalog);
        //this.groupedByCategory();    
    }
    const setActivePage = (page) =>{
        //console.log('setActivePage=====',page)
        setActive(page ? page : 'menu');
    }
    const getAllCategories = async() =>{
        try {
            var result = await crmservices.orders.getProductCategories({ return_all: true });
            //console.log('MenuItemsController== getAllCategories')
            if (result.code == 'OK') {
                setAllCategories(result.data.content)
            }
        } catch (error) {
            console.log("get all categories exception:", error);
        }
    }
    const onLoadCategories = async() =>{
        onShowLoading(true);
        try {
            var result = await crmservices.orders.getProductCategories();
           // console.log('MenuItemsController== onLoadCategories result=', result)
            if (result.code == 'OK') {
                var categories = result.data && result.data.content ? result.data.content : [];
                if (categories.length > 0) {
                    setCategorySelected(categories[0]);
                    await onLoadSubCategory(categories[0].id);

                }
                setOrderCache(order_key.order_categories, categories);
            }
        } catch (error) {
            console.log("on load categories exception:", error);
        }
        onShowLoading(false);
    }
    const onLoadSubCategory = async(parentID) =>{
        try {
            var result = await crmservices.orders.getProductCategories({ parent_id: parentID });

            if (result.code == 'OK') {
                //var categories = [{ id: "All", value: 'All', name: "All" }];
                //categories = categories.concat(result.data.content);
                setSubCategories(result.data.content ? result.data.content : []);
                setSubCategorySelected(result.data.content?result.data.content[0]:undefined);
                await onLoadMenuItems({ category_id: result.data.content && result.data.content[0]?result.data.content[0].id:undefined });
               // this.groupedByCategory();
            }
        } catch (error) {
            console.log("load sub category:", error);
        }
    }
    const onLoadMenuItems = async(params, orderCatalog) =>{
        try {
            var delivery_fulfilled_by = getOrderCache(order_key.delivery_fulfilled_by);
            var pick_up_store = getOrderCache(order_key.pick_up_store)
           // console.log('delivery_fulfilled_by===', delivery_fulfilled_by)
            if (!params)
                params = {}
            params.supply_method = order_type;
            if (delivery_fulfilled_by && order_type === 'DELIVERY')
                params.fulfilled_by = delivery_fulfilled_by.id
            else if (pick_up_store)
                params.fulfilled_by = pick_up_store.id
            if (orderCatalog && orderCatalog.id) {
                    params.order_catalog_id = orderCatalog.id;
                    params.order_category_id = params.category_id;
                    delete params.category_id;
                }
            //console.log("onLoadMenuItems params:", params);
            var result = await crmservices.orders.getProducts(params);
            //console.log("onLoadMenuItems= result:", result);
            if (result.code == 'OK') {
                onOrderCache(result.data)
                setMenuItems(result.data.content);
            }
        } catch (error) {
            console.log("on load categories exception:", error);
        }
       
    }
    const onReloadMenuItems = async() =>{
        await getAllCategories();
        await onLoadCategories();
    }
    const onOrderCache = async(order_items)=>{
       // console.log('setOrderCache  order_items=',order_items)
        var old_order_items = getOrderCache(order_key.order_items)
        var newItems = {}
        if ((old_order_items&&old_order_items.paging &&old_order_items.paging.page&&old_order_items.paging.page === order_items.paging.page) || order_items.paging.page === 1 || order_items.content.length === 0)
            newItems = order_items;
        else {
            //console.log('setOrderCache old_order_items =',old_order_items)
            newItems.paging = (order_items.paging);
            newItems.content = old_order_items.content.concat(order_items.content);
        }
        //console.log('setOrderCache  newItems=',newItems)
        setOrderCache(order_key.order_items, newItems)
        //console.log('setOrderCache  newItems=',getOrderCache(order_key.order_items))
    }
    const onSelectCategory = async(category) =>{
        setCategorySelected(category);
        onShowLoading(true);
        setHasMore(true);
        if (!orderCatalog)
            await onLoadSubCategory(category.id);
        else
            await getOrderSubCategories(category.id, orderCatalog)    

        onShowLoading(false);    
    }

    const onSelectSubCategory = async(category) =>{
        var subCategory = null
        //console.log('onSelectSubCategory category========', category)
        setSubCategorySelected(category);
        setHasMore(true);
        var catID = category.id;
        if (category.id === 'All') {
            catID = categorySelected.id;
        }else{
            subCategory = category.id
        }
        onShowLoading(true);
        await onLoadMenuItems({ category_id: catID }, orderCatalog);
       // this.groupedByCategory(subCategory);
       onShowLoading(false);
    }
    const handleLoadMore = async() =>{
       // console.log('handleLoadMore paging=')
       onShowLoadMore(true);
        try {
            var paging = getOrderCache(order_key.order_items).paging;
           // console.log('handleLoadMore paging=',paging)
            if ( paging && paging.size >= 100) {
                
                var params = {};
                var page = paging && paging.page ? paging.page + 1 : 0;
                params.page = page;
                if (subCategorySelected && subCategorySelected.id != 'All')
                    params.category_id = subCategorySelected.id;
                else
                    params.category_id = categorySelected.id;
                await onLoadMenuItems(params, orderCatalog);
                //this.groupedByCategory();
            }
            else{
                //console.log('handleLoadMore setState hasMore=false')
                setHasMore(false);
            }
        } catch (error) {
            console.log("load rewards transactions error:", error);
        }
        onShowLoadMore(false);
    }

    const loadProductVariations = async(productId) =>{

        var variations = [];
        try {
            var result = await crmservices.orders.getProductVariations(productId, order_type);
           //console.log("loadProductVariations result:", result);
            if (result.code == 'OK') {
                if (result.data) {
                    variations = result.data;
                }
            }
        } catch (error) {
            console.log("load product component exception:", error);
        }
        setVariations(variations);
    }
    const onClickItem = async(item) =>{
        console.log(' onClickItem===', item)
        onShowLoadingProcess(true);
        setMode('add');

        if(item.type_composition){ 
            if(item.type_composition == 'FLAT' || item.type_composition=='COMPOSITE' || item.type_composition=='FLEXIBLE_BUNDLE'){ 
                await loadProductVariations(item.id);
            }
        }

        //console.log(' onClickItem=== result=', result)
        
        await setBeingSelected(item);
        onShowLoadingProcess(false);
        setActive('extra');
        setProductSelected(null);
    }
    const onEstimateOrder = async(use_wallet_funds, payment_method_type, request_amount_from_wallet_funds, refeshFundWallet) =>{
        //console.log('refeshFundWallet====',refeshFundWallet)
        onShowLoadingProcess(true);
        var cart = getOrderCache(order_key.cart);
        const address = getOrderCache(order_key.delivery_address)

        //console.log("onEstimateOrder cart:", cart);
        try {
            var body = {
                supply_method: order_type,
                line_items: dataUtil.getLineItems(cart),
            }
            if(order_type === 'DELIVERY'){
                if (address.id)
                    body.address_id = getOrderCache(order_key.delivery_address).id
                else{
                    body.current_location = {}
                    body.current_location.address_line_1 = address.address_line_1
                    body.current_location.address_line_2 = address.address_line_2
                    body.current_location.state_province_county = address.state_province_county
                    body.current_location.postal_code = address.postal_code
                    body.current_location.country_code = address.country_code
                    body.current_location.lat = address.lat
                    body.current_location.lon = address.lon
                    body.current_location.town_city = address.town_city
                    body.current_location.googlePlaceId = address.googlePlaceId
                }
                    
            }
            if (order_type === 'PICK_UP' || order_type === 'DIRECT_SALE') {
                body.fulfilled_by = getOrderCache(order_key.pick_up_store).id;
            } else {
                body.fulfilled_by = getOrderCache(order_key.delivery_fulfilled_by).id;
            }
            if(order_notes){
                body.notes = order_notes;
            }
            if(use_wallet_funds!=undefined){
                body.use_wallet_funds = use_wallet_funds
            }else if (isUseWalletFund != undefined){
                body.use_wallet_funds = isUseWalletFund
            }
            else{
                setUseWalletFund(undefined)
            }
            if (body.use_wallet_funds && request_amount_from_wallet_funds && !refeshFundWallet)
                body.wallet_funds_amount = Number(request_amount_from_wallet_funds);
            else if(body.use_wallet_funds && requestAmountFromWalletFunds && !refeshFundWallet)
                body.wallet_funds_amount = Number(requestAmountFromWalletFunds);
            
            // if (payment_method_type){
            //     body.payment_method_type = payment_method_type
            // }
            //console.log('getOrderCache(order_key.pick_up_store)===',getOrderCache(order_key.pick_up_store))
            //console.log('getOrderCache(order_key.delivery_fulfilled_by)===',getOrderCache(order_key.delivery_fulfilled_by))
            if (payment_method_type){
                body.payment_method_type = payment_method_type
            } else if(paymentMethod){
                body.payment_method_type = paymentMethod
            }
            else{
                var paymentMethodTypes = order_type === 'PICK_UP' || order_type === 'DIRECT_SALE' ? getOrderCache(order_key.pick_up_store).payment_method_types : getOrderCache(order_key.delivery_fulfilled_by).payment_method_types;
                if(paymentMethodTypes && paymentMethodTypes.length == 1){
                    body.payment_method_type = paymentMethodTypes[0]
                    setPaymentMethod(paymentMethodTypes[0]);
                }
                else if(paymentMethodTypes && paymentMethodTypes.length > 1 && primary_card){
                    body.payment_method_type = 'CARD'
                    setPaymentMethod('CARD');
                }
            }

            if (body.payment_method_type == 'VNPAY'){
                body.payment_method_type = 'CASH'
            }

            //console.log('onEstimateOrder body=======',body)
            var result = await crmservices.orders.estimateOrder(body);
            console.log('onEstimateOrder result=======',result)
            var estimate_order_result = {}
            if (result.code === 'OK') {
                estimate_order_result = result.data;
                if(refeshFundWallet){
                    var availabelWalletFund = estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.wallet_funds_amount ? estimate_order_result.invoice_estimate.wallet_funds_amount : 0
                    setRequestAmountFromWalletFunds(undefined);
                    setAvailabelWalletFund(availabelWalletFund);
                }   
                let estimateCartItems = dataUtil.createEsitmateCartItems(estimate_order_result,cart);
                setOrderCache(order_key.estimate_cart_item, estimateCartItems);
                setOrderCache(order_key.estimate_order_result, estimate_order_result);
                setActivePage('cart');
            }else if(result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION'){
                setActivePage('cart')
                showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'))
            } else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED'){
                setActivePage('cart')
                showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
            } else if (result.code == 'SERVICE_ALREADY_EXIST') {
                showMessage(true, t('SERVICE_ALREADY_EXIST'));
            } else {
                showMessage(true, t('EXCEPTION_PROCESS'))
            }
            if (result.code != 'OK') {                
                clearCartItems();
            }
            setTotalAmountBaseItem(dataUtil.getTotalBaseItems(cart));
            setOrderCache(order_key.estimate_order_result, estimate_order_result);
            onShowLoadingProcess(false);
            return estimate_order_result;
        } catch (error) {
            console.log("On estimate order error:", error);
            showMessage(true, t('EXCEPTION_PROCESS'))
        }
        onShowLoadingProcess(false);
    }

    const onNextWithPaymentMethod = async(paymentMethod) =>{
      //  console.log('onNextWithPaymentMethod paymentMethod==',paymentMethod)
        setPaymentMethod(paymentMethod)
        await onEstimateOrder(isUseWalletFund, paymentMethod);
        setActivePage('cart');
    }
    const editCartItem = async(item) =>{
        var variations = item.variations;
        setMode('edit');
        setVariations(variations);
        setVariationSelected(item.variant_selected);
        setProductSelected(item);
        

        if(!variations && item.type){ 
            if(item.type == 'FLAT' || item.type == 'COMPOSITE' || item.type == 'FLEXIBLE_BUNDLE'){ 
                await loadProductVariations(item.id);
                await setBeingSelected(item);
            }
        }


        // if(!variations){
        //     await loadProductVariations(item.id);
        //     await setBeingSelected(item);
        // }
        // else{
            
        // }
        console.log("editCartItem item:", item);
        setActivePage('extra')
    }
    const onShowPaymentMethod = async() =>{
        //console.log('requested_delivery_at==',requested_delivery_at)
        onShowLoadingProcess(true);
        await onLoadCards();
        onShowLoadingProcess(false);
        setActivePage('select_method');
    }
    const onLoadCards = async() =>{
        try {
            var result = await crmservices.contacts.getListPaymentMethods();
            if (result.code == 'OK') {
                var cards = result.data && result.data.content ? result.data.content : [];
                if (cards.length > 0) {
                    var cardPrimary = cards.filter(card => {
                        return card.payment_method_type=='CARD' && card.is_primary
                    })
                    if (cardPrimary && cardPrimary.length > 0) {
                        setPrimaryCard(cardPrimary[0]);
                    }
                    var paypalPrimary = cards.filter(card => {
                        return card.name=='PayPal' && card.is_primary
                    })
                    if (paypalPrimary && paypalPrimary.length > 0) {
                        setPrimaryPaypal(paypalPrimary[0]);
                    }
                }
            }
        } catch (error) {
            console.log("load my order exception:", error);
        }
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        onShowLoadingProcess(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }


    const onSelectMerchants = () =>{
        var order_type = getOrderCache(order_key.order_type,true);
        if (order_type === 'DELIVERY') {
            setActive('select_merchant');
        } else {
            setActive('select_store');
        }
    }
    const onAddCard = async() =>{
        onShowLoading(true);
        try {
            let token = newGUID();
            let responseURL = window.location.origin + portalCfg.basename + '/process_addcard/' + token;

            let result = await crmservices.contacts.createFormToAddCard(responseURL);
            console.log(' onPrepareForm result===', result)
            if (result.code == 'OK') {
                //window.document.write(result.data);
                setAddCardInfo({token: token});
                setHtmlAddCardContent(result.data);
                setActive('add_card');
            }
        } catch (error) {
            console.log("on create form to add card exception:", error);
        }
        onShowLoading(false);
    }
    const onCloseAddCard = async() =>{
        onShowLoadingProcess(true);
        await onLoadCards();
        onShowLoadingProcess(false);
        setActive('select_method')
    }

    const onClose = () =>{
        if(dataUtil.getTotalCartQuantity(getOrderCache(order_key.cart)?getOrderCache(order_key.cart):[])>0)
            showConfirm(true, t('warning_leave_cart'));
        else
            props.onClose()
    }
    const showConfirm = (status, message) =>{
        onShowLoading(false);
        setConfirm({
            show: status,
            content: message ? message : null
        })
    }

    const onCloseChangeCard = async() =>{
        setActive('select_method');
        onShowLoading(true);
        await onLoadCards();
        onShowLoading(false);
    }
    const handleOnChangeAddNote = (event) =>{
        if (event && event.target && event.target.value) {
            setOrderNotes(event.target.value);
        } else {
            setOrderNotes('');
        }
    }
    return (
        <div>
            {active == 'menu' && <MenuItems
                showLoading={showLoading}
                showLoadingProcess={showLoadingProcess}
                open={props.open}
                onClose={props.onClose}
                currency={getCurrency()}
                order_type={order_type}
                deliveryAddress={getOrderCache(order_key.delivery_address)}
                pickupStoreAddress={getOrderCache(order_key.pick_up_store)}
                order_categories={getOrderCache(order_key.order_categories) ? getOrderCache(order_key.order_categories) : []}
                menuItems={menuItems}
                categorySelected={categorySelected}
                subCategorySelected={subCategorySelected}
                sub_categories={subCategories}
                onSelectCategory={onSelectCategory}
                onSelectSubCategory={onSelectSubCategory}
                onClickItem={onClickItem}
                carts={getOrderCache(order_key.cart) ? getOrderCache(order_key.cart) : []}
                setActivePage={setActivePage}
                onEstimateOrder={onEstimateOrder}
                delivery_fulfilled_by={getOrderCache(order_key.delivery_fulfilled_by)}
                accept_change_fulfilled={getOrderCache(order_key.accept_change_fulfilled)}
                onSelectMerchants={onSelectMerchants}
                handleLoadMore = {handleLoadMore}
                hasMore = {hasMore}
                showLoadMore = {showLoadMore}
                totalQuantity = {dataUtil.getTotalCartQuantity(getOrderCache(order_key.cart) ? getOrderCache(order_key.cart) : [])}
                menuItemLength={menuItemLength}

            />}
            {active == 'select_merchant' && <OrderMerchantsController
                showLoading={showLoading}
                showLoadingProcess={showLoadingProcess}
                open={active == 'select_merchant'}
                onClose={() => setActivePage("menu")}
                showMessage={showMessage}
                onReloadMenuItems = {onReloadMenuItems}
            />}
            {active == 'select_store' && <OrderStoresController
                showLoading={showLoading}
                showLoadingProcess={showLoadingProcess}
                open={active == 'select_store'}
                onClose={() => setActivePage("menu")}
                onReloadMenuItems = {onReloadMenuItems}
                
            />}
            {active == 'extra' && <ExtraItem
                showLoading={showLoading}
                open={active == 'extra'}
                onClose={props.onClose}
                currency={getCurrency()}
                product_selected={product_selected}
                variations={variations}
                mode={mode}
                setActivePage={setActivePage}
                variationSelected={variationSelected}
            />}
            {active == 'cart' && <Carts
                showLoading={showLoading}
                open={active == 'cart'}
                onClose={props.onClose}
                currency={getCurrency()}
                setActivePage={setActivePage}
                editCartItem={editCartItem}
                onEstimateOrder={onEstimateOrder}
                totalAmountBaseItem={totalAmountBaseItem}
                isUseWalletFund={isUseWalletFund}
                paymentMethod={paymentMethod}
                onShowPaymentMethod={onShowPaymentMethod}
                primary_card={primary_card}
                order_type = {order_type}
                onSelectCrossellProduct = {onClickItem}
                request_amount_from_wallet_funds={requestAmountFromWalletFunds}
                isValidAmountWalletFund = {isValidAmountWalletFund}
                availabelWalletFund={availabelWalletFund}
                order_notes={order_notes}
                handleOnChangeAddNote={handleOnChangeAddNote}
                setUseWalletFund={setUseWalletFund}
                setAvailabelWalletFund={setAvailabelWalletFund}
                setValidAmountWalletFund={setValidAmountWalletFund}
                setRequestAmountFromWalletFunds={setRequestAmountFromWalletFunds}
            />}
            {active == 'order_preview' && <PlaceOrder
                showLoading={showLoading}
                open={active == 'order_preview'}
                onClose={props.onClose}
                currency={getCurrency()}
                setActivePage={setActivePage}
                isUseWalletFund={isUseWalletFund}
                requestAmountFromWalletFunds={requestAmountFromWalletFunds}
                paymentMethod={paymentMethod}
                primary_card={primary_card}
                primary_paypal={primary_paypal}
                order_notes={order_notes}
            />}
            {active == 'select_method' && <SelectPaymentMethodController
                showLoading={showLoading}
                open={active == 'select_method'}
                onClose={()=>setActive('cart')}
                setActivePage={setActivePage}
                primary_card={primary_card}
                primary_paypal={primary_paypal}
                onAddCard={onAddCard}
                onChangeCard={()=>setActive('change_card')}
                onNext={onNextWithPaymentMethod}
                order_type={order_type}
                paymentMethod={paymentMethod} />}
            {active==='add_card'&&<AddCard
                open={active==='add_card'}
                onClose={onCloseAddCard}
                html_add_card_content = {html_add_card_content}/>}
                {active==='change_card'&&<Cards
                open={active == 'change_card'}
                onCloseItem={onCloseChangeCard}
                fromOrder
                />}
            {showLoadingProcess && <Loading showLoading={showLoadingProcess} />}
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
            {confirm && <ModalConfirm
                open={confirm.show}
                message={confirm.content}
                confirm={t('yes')}
                onClose={() => showConfirm(false)}
                onAction={props.onClose}
            />}

        </div>
    );
}

export default MenuItemsController;